import React, { useMemo } from 'react';
import Select from 'react-select';
import { FieldError, Controller } from 'react-hook-form';

type SelectOption = {
  id: string;
  label: string;
  disabled?: boolean;
  selected?: boolean;
};

const MultiSelectInput: React.FC<{
  id: string;
  label: string;
  ariaLabel?: string;
  control: any;
  options: SelectOption[];
  values?: SelectOption[] | SelectOption;
  error?: FieldError;
  placeholder?: string;
  isMulti?: boolean;
  className?: string;
  labelClassName?: string;
  placeholderClassName?: string;
  errorClassName?: string;
}> = ({
  id,
  label,
  ariaLabel,
  control,
  options,
  values,
  error,
  placeholder = 'Sélectionnez...',
  isMulti = true,
  className = 'inline-block relative w-full',
  labelClassName = 'block text-neutral-700 text-body-sm font-medium mb-2',
  placeholderClassName = 'text-neutral-500',
  errorClassName = 'italic text-body-sm text-danger-600 mt-1',
}) => {
  const errorComponent = useMemo(
    () => error?.message && <p className={errorClassName}>{error.message}</p>,
    [error?.message],
  );

  return (
    <div className={className}>
      {!!label && (
        <label className={labelClassName} htmlFor={id}>
          {label}
        </label>
      )}
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <Select
            styles={{
              control: (provided) => ({
                ...provided,
              }),
              option: (provided) => ({
                ...provided,
              }),
              singleValue: (provided) => ({
                ...provided,
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={
              typeof window !== 'undefined' ? document.body : null
            }
            inputId={id}
            aria-label={ariaLabel}
            options={options}
            value={values}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.label}
            placeholder={<p className={placeholderClassName}>{placeholder}</p>}
            isMulti={isMulti}
            isSearchable
            onChange={field.onChange}
          />
        )}
      />

      {errorComponent}
    </div>
  );
};

export default MultiSelectInput;
